<template>
    <div>
        <div class="nav"><span :class="{ 'active': boxName==1 }"   @click="clickNav(1)">宣传网站信息</span><span :class="{ 'active': boxName==2 }" @click="clickNav(2)">SEO设置</span></div>
        <div>
            <div class="box" v-show="boxName==1">  <WebForm :changeTabs="changeTabBox" @changNav="changNav"></WebForm></div>
            <div class="box" v-show="boxName==2">  <SeoForm :changeTabs="changeTabBox" @changNav="changNav"></SeoForm></div>
        </div>
    </div>
</template>

<script>
    import WebForm from "./components/webForm";
    import SeoForm from "./components/seoForm";
    import API from "./api"
    export default {
        name: "index",
        data() {
            return {
                boxName:1,
                changeTabBox:1,
                changeTabSeo:null,
                webValue: {}
            };
        },
        components: { WebForm,SeoForm },
        created () {
            this.$store.state.adminleftnavnum="/SiteSettings/WebsiteInformation"; //设置左侧导航2-2 active
        },
        methods: {
            changNav(key){
                this.boxName=key
            },
            clickNav(key){
                let _this=this
                if(key==2){
                    //seo
                 if(this.$children[0].changetab==2){
                     this.$confirm({
                         title: "提示",
                         content: "数据没保存，是否保存",
                         onOk() {
                             _this.$children[0].checkVal()
                             _this.boxName=2
                             _this.changeTabBox=2
                         },
                         onCancel() { _this.$children[0].getFormData() ;_this.boxName=2;  _this.changeTabBox=2},
                     });

                 }else{
                     _this.changeTabBox=2
                     _this.boxName=2

                 }
                }else{
                    if(this.$children[1].changetaba==2){
                        this.$confirm({
                            title: "提示",
                            content: "数据没保存，是否保存",
                            onOk() {
                                _this.$children[1].checkVal()
                                _this.boxName=1
                                _this.changeTabBox=1
                            },
                            onCancel() {_this.$children[1].getFormData()  ;_this.boxName=1;  _this.changeTabBox=1},
                        });
                    }else{
                        _this.changeTabBox=1
                        _this.boxName=1;

                    }

                }
            },
            callback(key) {

            }
        },
        mounted() {
        }
    };
</script>

<style scoped>
    .nav{margin: 0 0 16px 0;
        border-bottom: 1px solid #e8e8e8;
        outline: none;
        transition: padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    }
    .nav span{position: relative;
        display: inline-block;
        box-sizing: border-box;
        height: 100%;
        margin: 0 32px 0 0;
        padding: 12px 16px;
        text-decoration: none;
        cursor: pointer;
        transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    }
    .nav span.active{
        color: #1890ff;
        font-weight: 500;
        border-bottom: 2px solid  #1890ff;
    }
</style>